import React from 'react';
const ImageSVG = ({ color = 'black', className, ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      className={className}
      {...props}
    >
      <path
        d="M1.36233 17.4535C1.53886 18.52 2.46547 19.3334 3.58203 19.3334H17.082C18.3247 19.3334 19.332 18.326 19.332 17.0834V12.7972M1.36233 17.4535C1.3424 17.3331 1.33203 17.2095 1.33203 17.0834V3.58337C1.33203 2.34073 2.33939 1.33337 3.58203 1.33337H17.082C18.3247 1.33337 19.332 2.34073 19.332 3.58337V12.7972M1.36233 17.4535L5.6606 13.1552C6.42564 12.4858 7.5445 12.4126 8.39028 12.9764L8.96313 13.3583C9.77831 13.9018 10.8517 13.8552 11.6168 13.2432L14.5959 10.8598C15.3553 10.2523 16.413 10.2047 17.2202 10.7253C17.3096 10.783 17.3893 10.8545 17.4645 10.9298L19.332 12.7972M9.20703 6.95837C9.20703 8.20105 8.19971 9.20837 6.95703 9.20837C5.71439 9.20837 4.70703 8.20105 4.70703 6.95837C4.70703 5.71573 5.71439 4.70837 6.95703 4.70837C8.19971 4.70837 9.20703 5.71573 9.20703 6.95837Z"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ImageSVG;
